common.View.create('admin::layouts.main.sidebar.Structure', {

    touchStartX: 0,
    touchEndX: 0,
    touchStartY: 0,
    touchEndY: 0,

    onDOMLoad() {
        let toggleSidebarButton = this.element.find('#toggleSidebarButton');
        let sidebarPreference = localStorage.getItem('sidebarPreference');

        this.fixClassesOnResize(toggleSidebarButton, sidebarPreference);
        this.manageAriaExpanded(toggleSidebarButton, sidebarPreference);
        this.initMobile();
        this.slideMenu();
    },

    initMobile()
    {
        $('.galaxyBurgerMenu').on('click', (event) => {
            $('.galaxyWrapper').toggleClass('openedMobile');
            $('.galaxySidebar').toggleClass('-translate-x-full');
        });
    },

    slideMenu() {
        const slideElements = this.element
            .add(this.element.find('.galaxySlideBar'))
            .toArray(); // Convert jQuery object to a native array for iteration

        slideElements.forEach((element) => {
            element.addEventListener('touchstart', (e) => {
                this.touchStartX = e.changedTouches[0].screenX;
                this.touchStartY = e.changedTouches[0].screenY;
            }, { passive: true }); // Passive listener

            element.addEventListener('touchmove', (e) => {
                this.touchEndX = e.changedTouches[0].screenX;
                this.touchEndY = e.changedTouches[0].screenY;

                this.swipingInDirection(e);
            }, { passive: true }); // Passive listener

            element.addEventListener('touchend', (e) => {
                this.touchEndX = e.changedTouches[0].screenX;
                this.touchEndY = e.changedTouches[0].screenY;

                this.doneSwipingInDirection();
            }); // No passive needed here since default behavior is not blocked
        });
    },

    getDraggedAmountPercentage(amountDragged, width)
    {
        let percentageDragged = amountDragged / width * 100;

        if( percentageDragged < -100 ) {
            return -100;
        } else if(percentageDragged > 0) {
            return 0;
        }

        return amountDragged / width * 100;
    },

    checkSwipeDirection() {
        if( this.touchEndX < this.touchStartX ) {
            return 'left';
        }

        if( this.touchEndX > this.touchStartX ) {
            return 'right';
        }

        if( this.touchEndY < this.touchStartY ) {
            return 'up';
        }

        if( this.touchEndY > this.touchStartY ) {
            return 'top';
        }
    },

    swipingInDirection(e)
    {
        let width = this.element.width();

        if( this.checkSwipeDirection() === 'left' || this.checkSwipeDirection() === 'right' ) {
            let touchX = e.changedTouches[0].screenX,
                amountDragged = this.getDraggedAmountPercentage(touchX - this.touchStartX, width);

            $('.galaxySidebar').css('transform', 'translateX('+ amountDragged +'%)');
        }
    },

    doneSwipingInDirection()
    {
        $('.galaxySidebar').css('transform', '');

        // Swipe left
        if( this.touchEndX < this.touchStartX && (this.touchEndX - this.touchStartX) < -20 ) {
            $('.galaxySidebar').addClass('-translate-x-full');
            $('.galaxyWrapper').removeClass('openedMobile');
        }

        // Swipe right
        if( this.touchEndX > this.touchStartX ) {
            $('.galaxySidebar').removeClass('-translate-x-full');
            $('.galaxyWrapper').addClass('openedMobile');
        }
    },

    manageAriaExpanded(toggleSidebarButton, sidebarPreference) {
        if ($(window).width() <= 1280 || sidebarPreference === 'false') {
            this.manageCloseSidebar(toggleSidebarButton);
        }

        this.initToggleSidebar(toggleSidebarButton);
    },

    initToggleSidebar(toggleSidebarButton) {
        toggleSidebarButton.on('click', () => {
            if (toggleSidebarButton.attr('aria-expanded') === 'true') {
                this.manageCloseSidebar(toggleSidebarButton);
            } else {
                this.manageExpandSidebar(toggleSidebarButton);
            }

            this.rememberSidebarPreference(toggleSidebarButton);
        });
    },

    rememberSidebarPreference(toggleSidebarButton) {
        localStorage.setItem('sidebarPreference', toggleSidebarButton.attr('aria-expanded'));

        $.ajax({
            url: toggleSidebarButton.data('preference') + '?preference=' + toggleSidebarButton.attr('aria-expanded'),
        });
    },

    manageExpandSidebar(toggleSidebarButton) {
        $('.galaxySidebar').removeClass('w-20').addClass('w-60');
        $('.galaxyWrapper').removeClass('small');
        if ($(window).width() > 768) {
            $('.baseOnSidebarPref').removeClass('md:ml-20').addClass('ml-60');
        }
        if ($(window).width() > 1280) {
            $('.galaxyContent').addClass('xl:pl-60');
        }

        toggleSidebarButton.attr('aria-expanded', 'true');
    },

    manageCloseSidebar(toggleSidebarButton) {
        $('.galaxySidebar').removeClass('w-60 xl:w-60').addClass('w-20');
        $('.galaxyWrapper').addClass('small');
        $('.galaxyContent').removeClass('xl:pl-60');
        $('.baseOnSidebarPref').removeClass('ml-60 xl:ml-60').addClass('md:ml-20');

        toggleSidebarButton.attr('aria-expanded', 'false');
    },

    manageToggleTextState(toggleSidebarButton, expanded = true) {
        if (expanded) {
            toggleSidebarButton.find('i').removeClass('inline-block xl:hidden hidden');
            toggleSidebarButton.find('span').addClass('hidden');
        } else {
            setTimeout(() => {
                toggleSidebarButton.find('i').addClass('hidden');
                toggleSidebarButton.find('span').removeClass('xl:inline-block hidden');
            }, 50);
        }
    },

    fixClassesOnResize(toggleSidebarButton, sidebarPreference) {
        $(window).resize(() => {
            if ($(window).width() <= 1280) this.manageCloseSidebar(toggleSidebarButton);
            if ($(window).width() >= 1280 && sidebarPreference === 'true')
                this.manageExpandSidebar(toggleSidebarButton);
        });
    },
});
